<div id="content" class="allcp-form" ng-controller="AccountController" ng-init="webhooks()">
    <div ng-include="'modules/company/menus/setting_menu.html'"></div>
    <div class="row">
        <div class="col-md-10 col-md-offset-1 white-tab">

            <ul class="nav nav-tabs hide-print" id="tabContent">
                <li class="active"><a target="_self" href="#woocommerce" data-toggle="tab">WooCommerce Anahtarı</a></li>
                <li><a target="_self" href="#" data-toggle="tab">Yakında...</a></li>
            </ul>

            <div class="tab-content">
                <div class="tab-pane active bg-white" id="woocommerce">
                    <div class="row">
                        <div class="col-md-12 p50">
                            <div class="webhook mt10">
                                <h4>
                                    WooCommerce Webhook Anahtarı
                                    <a href="#" ng-click="createWebhook()" ng-if="data.token.length == 0" class="btn btn-primary btn-sm pull-right">
                                        <i class="fa fa-plus"></i>
                                        WooCommerce Anahtarı Oluştur
                                    </a>
                                </h4>
                                <code class="p20 mb10" ng-if="data.token.length != 0" style="display:block"> 
                                    https://uygulama.Hodxpress.com/webhook/woocommerce?access_token={{ data.token[0].access_token }}
                                </code>
                                <p>
                                    <i class="fa fa-question-circle"></i> 
                                    Bu anahtar ile wordpress WooCommerce E-Ticaret altyapısını kullanan yazılımınıza gelen siparişler teleskop ile entegre edebilirsiniz.
                                </p>
                                <h4>Nasıl Kullanılır ?</h4>

                                <p>
                                    <img src="img/woocommerce-webhook-tutorial/1.png" alt="">
                                    <br />
                                    <span class="tutorial-number">1</span> Öncelikle admin panelinize girerek resimde görünen menüden "Ayarlar" linkine tıklıyoruz.
                                    <hr >
                                </p>

                                <p>
                                    <img src="img/woocommerce-webhook-tutorial/2.png" alt="">
                                    <br />
                                    <span class="tutorial-number">2</span> Daha sonra karşımıza gelen bu sayfada resimde görünen tab kısmındaki "API" linkine tıklıyoruz.
                                    <hr >
                                </p>
                                <p>
                                    <img src="img/woocommerce-webhook-tutorial/3.png" alt="">
                                    <br />
                                    <span class="tutorial-number">3</span> API linkine tıkladıktan sonra karşımıza açılan sayfada resim göründüğü gibi bir menü açılacaktır. Bu kısımda ki Web Kancası Ekle butonuna tıklıyoruz.
                                    <hr >
                                </p>
                                <p>
                                    <img src="img/woocommerce-webhook-tutorial/4.png" alt="">
                                    <br />
                                    <span class="tutorial-number">4</span> Son olarak Web Kancası Ekle butonuna tıkladıktan sonra açılan sayfada ki bu formu doldurmamız gerekmektedir. Öncelikle isim kısmına istediğiniz herhangibir isim yazabilirsiniz. Durum kısmını aktif yapmamız gerekiyor. Başlık kısmını sipariş oluşturuldu yapıyoruz.Teslim bağlantısı bölümüne yukarıda size oluşturmuş olduğumuz linki kopayalıp girmeniz gerekmektedir. Gizli anahtar kısmını boş bırakarak Web Kancasını Kaydet butonuna tıklayarak işlemimizi tamamlıyoruz. Daha sonra E-Ticaret sitenizden bir tane sipariş oluşturarak sistemin sorunsuz çalıştığını test ediniz.
                                    <hr >
                                </p>
                                <p>
                                    <strong> Not:</strong> Bu sistemle oluşturduğunuz siparişleriniz Teleskop'ta kayıtlı olan personellerinizden sırayla birisine atanacaktır.
                                </p>


                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>